import React from "react";
import { iconProps } from "../../../../Helper";

export const ImageTranscaptionIcon = ({ className }: iconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_11934_97253"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
           
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_11934_97253)">
        <g clipPath="url(#clip0_11934_97253)"  >
          <rect
            x="1.375"
            y="7.375"
            width="7.25"
            height="7.25"
            stroke="white"
            strokeWidth="0.75"
            className={`${className}-stroke`}
          />
          <path
            d="M5.32373 9.44531V13H4.71582V9.44531H5.32373ZM6.43945 9.44531V9.93359H3.60986V9.44531H6.43945Z"
            fill="white"
            className={className}
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 10H13.1493C13.387 10 13.5882 9.91765 13.7529 9.75294C13.9176 9.58824 14 9.38702 14 9.14929V2.85071C14 2.61298 13.9176 2.41176 13.7529 2.24706C13.5882 2.08235 13.387 2 13.1493 2H6.85071C6.61298 2 6.41176 2.08235 6.24706 2.24706C6.08235 2.41176 6 2.61298 6 2.85071V6H6.70588V2.85071C6.70588 2.81447 6.72098 2.78129 6.75118 2.75118C6.78129 2.72098 6.81447 2.70588 6.85071 2.70588H13.1493C13.1855 2.70588 13.2187 2.72098 13.2488 2.75118C13.279 2.78129 13.2941 2.81447 13.2941 2.85071V9.14929C13.2941 9.18553 13.279 9.21871 13.2488 9.24882C13.2187 9.27902 13.1855 9.29412 13.1493 9.29412H10V10ZM10 8.23529H12.5067L10.9593 6.172L10 7.42034V8.23529Z"
          fill="white"
          className={className}
        />
      </g>
      <defs>
        <clipPath id="clip0_11934_97253">
          <rect
            x="1"
            y="7"
            width="8"
            height="8"
            rx="1"
            fill="white"
            className={className}
          />
        </clipPath>
      </defs>
    </svg>
  );
};
